import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const REACT_APP_FIREBASE_KEY="AIzaSyCkyFa5ag_ck0xsIEAvtp24FfZOllfiPvY"
const REACT_APP_FIREBASE_DOMAIN="prayer-journal-e2e93.firebaseapp.com"
const REACT_APP_FIREBASE_DATABASE="https://prayer-journal-e2e93.firebaseio.com"
const REACT_APP_FIREBASE_PROJECT_ID="prayer-journal-e2e93"
const REACT_APP_FIREBASE_STORAGE_BUCKET="prayer-journal-e2e93.appspot.com"
const REACT_APP_FIREBASE_SENDER_ID=901455867465

const fire = firebase.initializeApp({
  apiKey: REACT_APP_FIREBASE_KEY,
  authDomain: REACT_APP_FIREBASE_DOMAIN,
  databaseURL: REACT_APP_FIREBASE_DATABASE,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_FIREBASE_SENDER_ID
});

fire.firestore().enablePersistence();

export default fire;